import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import CloseIcon from '@mui/icons-material/Close';

import { selectUsersForNamesById } from '../../../store/userSelectors';
import { loadUsersMinimalDetails } from '../../../store/userService';
import { uuid } from '../../../utils/stringUtils';

import ActionHistory from './ActionHistory';
import StatusHistory from './StatusHistory';

import app from '../../../app.module.css';
import dropdown from '../../../commonStyles/rowExpand.module.css';

const ValidationRowDetails = ({ row, onClose }) => {
    const dispatch = useDispatch();

    // LOCAL STATE
    const [currentAndHistoryStatus, setCurrentAndHistoryStatus] = useState([]);
    const [currentAndHistoryActionStatus, setCurrentAndHistoryActionStatus] = useState([]);
    const [missingIds, setMissingIds] = useState([]);

    // STORE STATE
    const users = useSelector(selectUsersForNamesById);

    // USEEFFECTS
    useEffect(() => {
        missingIds.length > 0 && setMissingIds([]);
    }, []);

    useEffect(() => {
        let userIds = [
            ...new Set(
                [...[...row.history, ...row.actionStatusHistory].map((el) => el.userId), row.userId]
                    .filter((el) => el?.toLowerCase() !== 'polaris system')
                    .filter((el) => el)
            )
        ];
        const missingIds = userIds.filter((el) => !(el in users));
        setMissingIds(missingIds);
        missingIds.length ? dispatch(loadUsersMinimalDetails(missingIds)) : configData();
    }, [row]);

    useEffect(() => {
        if (missingIds.length < 1) return;
        if (Object.keys(users).length > 0) configData();
    }, [users]);

    // FNS
    const configData = () => {
        const updatedCurrentAndHistoryStatus = row.history.map((el) => ({
            ...el,
            emailAddress: users[el.userId]?.loginEmailAddress || 'Polaris System'
        }));
        setCurrentAndHistoryStatus([
            {
                status: row?.status,
                reason: row?.reason,
                date: row.lastStatusUpdated,
                notes: row.notes,
                userId: row.userId,
                emailAddress: users[row.userId]?.loginEmailAddress || 'Polaris System'
            },
            ...updatedCurrentAndHistoryStatus
        ]);

        const updatedCurrentAndHistoryActionStatus = row.actionStatusHistory.map((el) => ({
            ...el,
            emailAddress: users[el.userId]?.loginEmailAddress || 'Polaris System'
        }));
        setCurrentAndHistoryActionStatus([
            {
                actionStatus: row?.actionStatus,
                date: row.lastActionStatusUpdated,
                actionNotes: row.actionNotes,
                userId: row.userId,
                emailAddress: users[row.userId]?.loginEmailAddress || 'Polaris System'
            },
            ...updatedCurrentAndHistoryActionStatus
        ]);
    };

    // RENDER
    return (
        <div className={`${dropdown.rowDropdown} ${dropdown.redBorder}`}>
            <div className={app.sectionHeading}>Status History</div>
            {currentAndHistoryStatus.map((el) => (
                <StatusHistory key={uuid()} history={el} />
            ))}

            <div className={dropdown.divider}>
                <div className={dropdown.dividerLine}></div>
            </div>

            <div className={`${app.sectionHeading}`}>Action History</div>
            {currentAndHistoryActionStatus.map((el) => (
                <ActionHistory key={uuid()} history={el} />
            ))}

            <div className={dropdown.exit} onClick={onClose}>
                Close details
                <CloseIcon />
            </div>
        </div>
    );
};

ValidationRowDetails.propTypes = {
    row: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired
};

export default ValidationRowDetails;
